import type { Project } from "./useProjects";
import useAllAnalyses from "./useAllAnalyses";
import type { Source } from "./useSources";
import useActiveAnalysesWithDisplayFilters from "./useActiveAnalysesWithDisplayFilters";

export default function useAnalyses(project: Project, source: Source, allAnalysesMode: boolean) {
  const { activeAnalyses } = useActiveAnalysesWithDisplayFilters(project.id);

  const { result: allAnalyses, description } = useAllAnalyses(
    project,
    source,
    allAnalysesMode,
    activeAnalyses,
  );

  const result = allAnalysesMode ? allAnalyses : activeAnalyses;
  return { result, samplingDescription: allAnalysesMode ? description : null };
}
